export default __webpack_public_path__ + "static/media/Heebo-Medium.7ce8ba47.ttf";